import React, { useState } from 'react';
import axios from 'axios';
const API_URI = process.env.REACT_APP_API_URI || 'http://localhost:5000';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const response = await axios.post(`${API_URI}/api/inquiries`, formData, {
        headers: { 'Content-Type': 'application/json' },
      });

      setSuccessMessage(response.data.message || 'Inquiry submitted successfully.');
      setFormData({ name: '', phone: '', email: '', message: '' }); // Reset the form
    } catch (error) {
      setErrorMessage(
        error.response?.data?.error || 'Failed to submit the inquiry. Please try again.'
      );
    }
  };

  return (
    <section className="bg-black text-white p-8">
      <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center">Contact</h2>
      <div className="container mx-auto">
        <form className="max-w-lg mx-auto space-y-4" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name" className="block text-lg md:text-xl font-medium mb-2">
              Name
            </label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full p-2 bg-gray-800 rounded-lg border border-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500"
            />
          </div>
          <div>
            <label htmlFor="phone" className="block text-lg md:text-xl font-medium mb-2">
              Phone No (Optional)
            </label>
            <input
              type="tel"
              id="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full p-2 bg-gray-800 rounded-lg border border-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500"
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-lg md:text-xl font-medium mb-2">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-2 bg-gray-800 rounded-lg border border-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500"
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-lg md:text-xl font-medium mb-2">
              Message
            </label>
            <textarea
              id="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="4"
              className="w-full p-2 bg-gray-800 rounded-lg border border-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500"
            ></textarea>
          </div>
          <div className="text-right">
            <button
              type="submit"
              className="px-4 py-2 bg-green-500 rounded-lg hover:bg-green-600 transition-all duration-500"
            >
              Submit
            </button>
          </div>
          {successMessage && (
            <p className="mt-4 text-green-500 font-medium">{successMessage}</p>
          )}
          {errorMessage && (
            <p className="mt-4 text-red-500 font-medium">{errorMessage}</p>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
